import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { HttpService } from 'services/http.service';
import { CompanyFacilityModel } from 'services/models/company-facility.model';
import { QueryParams } from 'services/models/odata/queryParams';
import { ServiceBase } from 'services/servicebase';
import { Response } from 'services/models/response';
import { guidEmpty } from 'utils/helps';
import { Filter } from 'services/models/odata/filter';

@Injectable()
export class CompanyFacilityService extends ServiceBase<CompanyFacilityModel> {
  constructor(http: HttpService) {
    super('company/facility', http, environment.apiUrl);
  }

  createEntity(input: any): CompanyFacilityModel {
    return CompanyFacilityModel.create(input);
  }

  listCompanyFacility(params: QueryParams = null): Observable<Response<CompanyFacilityModel[]>> {
    return this.customList<CompanyFacilityModel>(params, `list`, CompanyFacilityModel);
  }

  createOrUpdate(data: CompanyFacilityModel): Observable<any> {
    if (data.id !== guidEmpty) {
      return this.http.put(`${this.endpoint}/update`, data, false);
    }

    return this.http.post(`${this.endpoint}/create`, data, null, null, false);
  }

  listCompanyFacilityByCompanyGroupId(
    companyGroupId: string
  ): Observable<Response<CompanyFacilityModel[]>> {
    const params = {
      select: ['*'],
      filter: Filter.equalToGuid('companyGroupId', companyGroupId),
    } as QueryParams;

    return this.customList<CompanyFacilityModel>(params, `list`, CompanyFacilityModel);
  }
}
